import { makeStyles } from '@fluentui/react-components';
export var useCarouselNavIconStyles = makeStyles({
    icon: {
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'nowrap',
        height: '100%',
        justifyContent: 'center',
    },
    iconDisabled: {
        pointerEvents: 'none',
    },
});
//# sourceMappingURL=CarouselNavIcon.styles.js.map